import { createMuiTheme, fade } from '@material-ui/core'
// Use createMuiTheme here is good for theme object key suggestion

let theme = (pcTheme) => {
  let mTheme = createMuiTheme(pcTheme, {
    palette: {
      primary: {
        main: '#1A285D',
        light: '#D1D7DD',
      },
      secondary: {
        main: '#F2512D',
      },
      supporting: {
        supporting01: '#A9BFCC',
        supporting02: '#D2C7BC',
      },
      assistant: {
        assistant01: '#29678F',
        assistant02: '#7BB8C8',
        assistant03: '#E0C38C',
        assistant04: '#E2E9EB',
        assistant05: '#F7F7FB',
      },

      divider: '#EBEBEC',
      grey: {
        50: '#EBEBEC',
        100: '#D7D8DA',
        200: '#C3C4C7',
        300: '#AFB1B5',
        400: '#888990',
        500: '#888990',
        600: '#74767E',
        700: '#60626B',
        800: '#4C4F59',
        900: '#24252B',
      },
      background: {
        default: '#F8F9FA',
      },
      text: {
        primary: '#24252B',
      },
    },
  })
  return createMuiTheme(mTheme, {
    props: {
      // 组件的名字 ⚛️
      MuiButtonBase: {
        // 需要应用的属性
        disableRipple: true, // 在整个应用中都不会有涟漪效果 💣！
      },
    },
    overrides: {
      MuiDivider: {
        root: {
          height: 0.5,
        },
      },
      MuiButton: {
        root: {
          borderRadius: 6,
          height: mTheme.spacing(5),
          fontSize: '1rem',
          lineHeight: 1.5,
          padding: mTheme.spacing(0.75, 1),
          '&:hover,&:active': {
            opacity: 0.85,
            boxShadow: 'none ',
          },
        },
        text: {
          padding: mTheme.spacing(0.75, 1),
        },
        outlined: {
          padding: mTheme.spacing(0.75, 1),
        },
        contained: {
          padding: mTheme.spacing(0.75, 1),
        },
        containedSecondary: {
          '&:hover,&:active': {
            boxShadow: 'none ',
          },
        },
        containedPrimary: {
          '&:hover,&:active': {
            boxShadow: 'none ',
          },
        },
        sizeSmall: {
          borderRadius: 6,
          fontSize: '0.75rem',
          lineHeight: 1.25,
          fontWeight: mTheme.typography.fontWeightMedium,
          height: mTheme.spacing(3.25),
          padding: mTheme.spacing(0.75, 1),
        },
        sizeLarge: {
          padding: mTheme.spacing(0.75, 1),
          width: '100%',
          maxWidth: 343,
        },
      },
      MuiTabs: {
        root: {
          minHeight: 'auto',
          boxShadow: `0 0.5px 0 0 ${mTheme.palette.grey[50]}`,
        },
        indicator: {
          height: 0,
          backgroundColor: 'transparent',
          '&:before': {
            content: '""',
            position: 'absolute',
            height: 3,
            width: `${mTheme.spacing(4)}px !important`,
            borderRadius: `16px 16px 0 0`,
            backgroundColor: mTheme.palette.secondary.main,
            left: '50%',
            bottom: 0,
            transform: 'translateX(-50%)',
          },
        },
      },
      MuiTab: {
        root: {
          minHeight: mTheme.spacing(5.75),
          paddingTop: mTheme.spacing(0.5),
          paddingBottom: mTheme.spacing(1),
          fontWeight: mTheme.typography.fontWeightMedium,
        },
        textColorInherit: {
          color: fade(mTheme.palette.common.black, 0.3),
          opacity: 1,
          '&$selected': {
            color: mTheme.palette.primary.main,
            fontWeight: mTheme.typography.fontWeightBold,
          },
        },
      },
      MuiAvatar: {
        rounded: {
          borderRadius: mTheme.spacing(0.75),
        },
        colorDefault: {
          backgroundColor: mTheme.palette.grey[50],
          '& path': {
            fill: mTheme.palette.grey[100],
          },
        },
      },
      MuiChip: {
        root: {
          borderRadius: 2,
        },
        labelSmall: {
          padding: mTheme.spacing(0, 1),
        },
        sizeSmall: {
          height: mTheme.spacing(2),
        },
        colorSecondary: {
          color: mTheme.palette.secondary.main,
          backgroundColor: fade(mTheme.palette.secondary.main, 0.1),
        },
        iconColorSecondary: {
          '& path': {
            fill: mTheme.palette.secondary.main,
          },
        },
        iconSmall: {
          marginLeft: mTheme.spacing(-1),
          marginRight: 0,
        },
      },
      MuiFormHelperText: {
        root: {
          marginBottom: mTheme.spacing(-1.5),
        },
      },
      MuiInputLabel: {
        root: {
          fontSize: mTheme.typography.caption.fontSize,
          color: mTheme.palette.grey[900],
          fontWeight: mTheme.typography.fontWeightMedium,
          // paddingLeft: mTheme.spacing(0.5),
        },
        asterisk: {
          color: mTheme.palette.secondary.main,
          position: 'absolute',
          top: 0,
          left: mTheme.spacing(-1),
        },
        shrink: {
          transform: `translate(0, 2px) scale(1)`,
        },
      },
      MuiFormControl: {
        marginNormal: {
          marginTop: mTheme.spacing(1.5),
          marginBottom: mTheme.spacing(1.5),
        },
      },
      MuiFormControlLabel: {
        label: {
          fontSize: mTheme.typography.caption.fontSize,
        },
      },
      MuiInput: {
        root: {
          paddingRight: mTheme.spacing(1),
        },
        input: {
          height: mTheme.spacing(2.25),
          '&::placeholder': {
            color: mTheme.palette.grey[200],
            opacity: 1,
          },
        },
        underline: {
          '&:before': {
            borderBottom: 'none',
          },
          '&:after': {
            // borderBottom: `1px solid ${mTheme.palette.grey[50]}`,
            borderBottom: 'none',
          },
        },
      },
    },
    typography: {
      h1: {
        fontSize: '1.5rem',
        lineHeight: 2,
      },
      h2: {
        fontSize: '1.375rem',
        lineHeight: 1.875,
      },
      h3: {
        fontSize: '1.125rem',
        lineHeight: 1.625,
      },
      h4: {
        fontSize: '1rem',
        lineHeight: 1.5,
      },
      h5: {
        fontSize: '0.875rem',
        lineHeight: 1.375,
      },
      h6: {
        fontSize: '0.75rem',
        lineHeight: 1.25,
      },
      body1: {
        fontSize: '0.875rem',
        lineHeight: 1.375,
      },
      body2: {
        fontSize: '0.75rem',
        lineHeight: 1.25,
      },
      button: {
        fontSize: '1rem',
        lineHeight: 1.5,
        fontWeight: mTheme.typography.fontWeightBold,
      },
      caption: {
        fontSize: '0.625rem',
        lineHeight: 1.125,
      },
      overline: { fontSize: '0.625rem', lineHeight: 1.125 },
    },
  })
}

export default theme
